import { useTranslation } from 'react-i18next';
import { SUPPORTED_LOCALES, type Locale } from './index';
import { supabase } from '@shared/supabase/client';
import { useAuth } from '@shared/auth/AuthContext';

export const LOCALE_LABEL: Record<Locale, string> = { ru: 'Русский', en: 'English', ky: 'Кыргызча' };

/** Current UI locale + a setter that also persists to profiles.locale.
 *  Shared by the desktop <select> and the mobile menu's language pills. */
export function useLocale() {
  const { i18n } = useTranslation();
  const { user } = useAuth();
  const locale = i18n.language.split('-')[0] as Locale;
  const setLocale = async (loc: Locale) => {
    await i18n.changeLanguage(loc);
    if (user) await supabase.from('profiles').update({ locale: loc }).eq('id', user.id);
  };
  return { locale, setLocale, locales: SUPPORTED_LOCALES, label: LOCALE_LABEL };
}
